import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FormattedDistance } from 'shared/units'
import styles from './_gearItem.css'

export function GearItem ({ item }) {
  const { _embedded: { gear }} = item
  return (
    <div className={styles.container}>
      <div className={styles.thumb}>
        <img className={styles.thumbImg} src={gear.thumbnail_url} />
      </div>
      <div className={styles.desc}>
        <div className={styles.name}>
          <a href='/gear/gear-locker'>{gear.model}</a>
        </div>
        <div className={styles.url}>
          <a href={gear.product_url}>
            <FormattedMessage id='gearitem.view.instore' defaultMessage='View on Zappos&#8482;' />
          </a>
        </div>
        <div className={styles.distance}>
          <FormattedDistance value={item.current_distance} />
        </div>
      </div>
    </div>
  )
}

GearItem.propTypes = {
  item: PropTypes.object,
}

export default GearItem



// WEBPACK FOOTER //
// ./src/components/home/gear/GearItem.jsx